import "./AllProjects.css"
import Organizer from "./Organizer"
import Project from "./Project"
import { useEffect, useState } from 'react';

function AllProjects() {
    const [original, setOriginal] = useState([]);
    const [displayed, setDisplayed] = useState([]);
    useEffect(() => {
        let projects = require("./Resources/projects");
        setOriginal(projects.projects);
        setDisplayed(projects.projects);
    }, []);

    function setItemsFunc(newArr) {
        setDisplayed(newArr);
    }


    let filters = [{"name": "A-Z", "var": "name"}, {"name": "Earliest", "var": "earliest"}, {"name": "Latest", "var": "latest"}]
return (
        <div className="AllProjects">
        <h1>Projects</h1>
        {/*organizer with name and earliest and latest filters*/}
        <Organizer filters={filters} setFunc={setItemsFunc} arr={original}/>
        {/*iterate over all projects*/}
            {displayed.map((item) => (
                <Project key={item.name} project={item}/>
            ))}
        </div>

    );
}

export default AllProjects;